import { useEffect, useState } from "react";
import { Save, Bot } from "lucide-react";
import { http, errMsg } from "../../api";

const FIELDS = [
  ["intro", "1 · Welcome & job explanation", "Shown first. Explain the work (Audible projects, AI narration, dialogue verification). Ends with Yes / No."],
  ["steps", "2 · Hiring steps overview", "Shown after Yes. Explain the 3 steps and both tests. Options: Yes / No / Return to previous / Main menu."],
  ["declined", "3 · When the candidate says No", "Shown after No. Only a Main menu option follows."],
  ["done", "4 · When the candidate agrees to start", "Shown after the final Yes; the hiring steps unlock. Options: Go to my hiring steps / Main menu."],
];

export default function OnboardingScriptEditor() {
  const [form, setForm] = useState(null);
  const [busy, setBusy] = useState(false);
  const [notice, setNotice] = useState(null);

  useEffect(() => { http.get("/admin/creator-onboarding-script").then(r => setForm(r.data)); }, []);
  if (!form) return <div className="loading">Loading chat script…</div>;

  const save = async () => {
    setBusy(true); setNotice(null);
    try {
      const { data } = await http.put("/admin/creator-onboarding-script", { agent_name: form.agent_name, intro: form.intro, steps: form.steps, declined: form.declined, done: form.done });
      setForm(data); setNotice({ tone: "success", text: "Chat script saved. New conversations use it immediately." });
    } catch (e) { setNotice({ tone: "error", text: errMsg(e) }); } finally { setBusy(false); }
  };

  return (
    <section className="form-card" data-testid="onboarding-script-editor">
      <h2><Bot size={18} /> Hiring assistant chat script</h2>
      <p>Every new creator must chat with this automated assistant before the hiring steps unlock. Edit the messages below; the Yes / No / Return / Main menu buttons are fixed. Use <code>{"{name}"}</code> to insert the candidate's first name.</p>
      <label>Assistant name</label>
      <input value={form.agent_name} onChange={e => setForm({ ...form, agent_name: e.target.value })} data-testid="script-agent-name" />
      {FIELDS.map(([key, title, hint]) => (
        <div key={key} style={{ marginTop: 16 }}>
          <div className="section-title"><span>{title.toUpperCase()}</span><span>{(form.options?.[key] || []).map(o => o.label).join(" · ")}</span></div>
          <small className="muted">{hint}</small>
          <textarea rows={key === "intro" || key === "steps" ? 9 : 3} value={form[key]} onChange={e => setForm({ ...form, [key]: e.target.value })} data-testid={`script-${key}`} />
        </div>
      ))}
      {notice && <div className={`notice ${notice.tone}`} style={{ marginTop: 14 }} data-testid="script-notice">{notice.text}</div>}
      <button className="primary" onClick={save} disabled={busy} style={{ marginTop: 14 }} data-testid="save-script"><Save size={15} /> {busy ? "Saving…" : "Save chat script"}</button>
    </section>
  );
}
